export default __webpack_public_path__ + "static/media/pia-rhona_saxe.53b96551.webp";